import React from 'react';
import { TextField, TextFieldProps } from '@carrotfertility/carotene-core';
import { useFormContext } from 'react-hook-form';
import { getFormInputState } from './form-utils';
import { ExtendRegisterOptionsProps, RequireNameProp } from './form-types';

export type FormTextFieldProps = TextFieldProps & ExtendRegisterOptionsProps & RequireNameProp;

export function FormTextField({
    registerOptions,
    name,
    error,
    helperText,
    label,
    ...otherProps
}: FormTextFieldProps): JSX.Element {
    const {
        register,
        formState: { errors, isSubmitting },
    } = useFormContext();

    const { error: hasError, helperText: helperTextValue } = getFormInputState({ name, errors, error, helperText });

    return (
        <TextField
            id={name}
            {...register(name, registerOptions)}
            {...otherProps}
            disabled={isSubmitting || otherProps.disabled}
            required={otherProps.required ? otherProps.required : Boolean(registerOptions?.required)}
            error={hasError}
            helperText={helperTextValue}
            label={label}
        />
    );
}
